// extracted by mini-css-extract-plugin
export var cardTitle = "_ia-1";
export var commentBubble = "_ia-e";
export var commentForm = "_ia-a";
export var commentInput = "_ia-b";
export var commentLabel = "_ia-d";
export var commentPrompt = "_ia-9";
export var csatCard = "_ia-0";
export var feedbackSection = "_ia-7";
export var starDisabled = "_ia-6";
export var starEmpty = "_ia-5";
export var starFilled = "_ia-4";
export var starWrapper = "_ia-3";
export var starsContainer = "_ia-2";
export var submittedComment = "_ia-c";
export var thankYouText = "_ia-8";